const apiUrl = process.env.REACT_APP_API_URL;

const config = {
  apiUrl,
};

export default config;
